<template>
    <div>
                <base-header style="background: rgba(79, 47, 129, 1);
background: radial-gradient(circle, rgba(79, 47, 129, 1) 25%, rgba(79, 47, 129, 0.73) 100%);" class="pb-6 pb-8 pt-5 pt-md-5">
            <!-- Card stats -->
            <!-- <div class="row">
              <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <h3 class="mb-0">Icons</h3>
                        </div>
                        <div class="card-body">
                            <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

                <!-- <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-red"
                                sub-title="350,897"
                                icon="ni ni-active-40"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-orange"
                                sub-title="2,356"
                                icon="ni ni-chart-pie-35"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 12.18%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Sales"
                                type="gradient-green"
                                sub-title="924"
                                icon="ni ni-money-coins"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-danger mr-2"><i class="fa fa-arrow-down"></i> 5.72%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>

                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Performance"
                                type="gradient-info"
                                sub-title="49,65%"
                                icon="ni ni-chart-bar-32"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 54.8%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div> -->
            <!-- </div> -->
        </base-header>

         <div class="container-fluid mt--7" :dir="language">
            <div class="row" style="z-index:1;">

                <div class="col-xl-7 mb-5 mb-xl-0" :dir="language">

                    <card  header-classes="bg-white" :dir="language" style="/*height:845px;*/">
                      <base-button class="btn-primary btn-sm" style="margin-top:-20px;" v-on:click="back">{{texts.back}}</base-button>
                       <h3 v-if="language=='ltr'">{{texts.deliverables}}</h3>
                       <h3 v-else style="text-align:right;">{{texts.deliverables}}</h3>

                      <card v-for="deliverable in deliverables" header-classes="bg-white" style="background-color: white;background: #fff;margin-bottom:27%;" :dir="language">

                        <div class="row" :dir="language" style="margin-top:-20px;">

                          <h2 class="col-8" v-if="language == 'ltr'">{{deliverable.title}}</h2><h2 class="col-8" v-else style="text-align:right;">{{deliverable.title}}</h2><div class="col-4"  style="width: 100%">
                          <button type="button" style="float: right;margin-top: 10px;" class="btn btn-primary col-12" v-on:click="onClick(deliverable)">{{texts.view}}</button>


                            </div>
                          <!-- <br> -->
                          <span class="col-8" v-if="language == 'ltr'">{{deliverable.description}}<br><br></span>
                          <span class="col-8" v-else style="text-align:right;">{{deliverable.description}}<br><br></span>
                          <br>
                          <!-- <br> -->
                          <!-- <br> -->
                          <span class="col-8" v-if="language=='ltr'">Uploaded : {{deliverable.date}}</span>
                          <span class="col-8" v-else style="text-align:right;">حملت : {{deliverable.date}}</span>
                          <button type="button" v-if="isManager" style="float: right;" class="btn btn-info btn-sm col-2" v-on:click="editDeliverable(deliverable)">{{texts.edit}}</button>
                        </div>

                      </card>
                      <br>


                    </card>
                </div>

                <div class="col-xl-5" v-if="loaded" :dir="language">
                    <card header-classes="bg-transparent" style="height:411px;">
                      <h3 v-if="language == 'ltr'">{{graph_text}}</h3>
                      <h3 v-else style="text-align:right;">{{graph_text}}</h3>
                        <center>

                          <div class="row text-center" v-if="findings_type === 'Internal Audit'">
                            <div class="col-md-1">
                              </div>

                            <div class="col-md-2">


                              <span class="badge badge-pill " style="font-size: 12px;background-color: #fff; color: black;width:50px;">{{texts.very_high}}</span>

                              <span class="badge badge-pill badge-danger" style="font-size: 16px;background-color: #bf2718; color: white;width:50px;">{{very_high_findings}}</span>

                            </div>
                            <div class="col-md-2">
                              <span class="badge badge-pill" style="font-size: 12px;background-color: #fff;  color:black;width:50px;">{{texts.high}}</span>
                              <span class="badge badge-pill badge-danger" style="font-size: 16px;background-color: #E74C3C; color: white;width:50px;">{{high_findings}}</span>
                            </div>
                            <div class="col-md-2">
                              <span class="badge badge-pill " style="font-size: 12px; background-color: #fff;color: black;width:50px;">{{texts.medium}}</span>
                              <span class="badge badge-pill badge-warning" style="font-size: 16px; background-color: #F39C12;color: white;width:50px;">{{medium_findings}}</span>
                            </div>
                            <div class="col-md-2">
                              <span class="badge badge-pill " style="font-size: 12px; background-color: #fff; color: black;width:50px;">{{texts.low}}</span>
                              <span class="badge badge-pill badge-danger" style="font-size: 16px; background-color: #F4D03F; color: white;width:50px;">{{low_findings}}</span>
                            </div>
                            <div class="col-md-2">
                              <span class="badge badge-pill " style="font-size: 12px;background-color: #fff; color: black;width:50px;">{{texts.very_low}}</span>
                              <span class="badge badge-pill badge-danger" style="font-size: 16px;background-color: #2ecc71; color: white;width:50px;">{{very_low_findings}}</span>
                            </div>







                          </div>
                          <div class="row text-center" v-if="findings_type === 'Risk Assessment'">
                            <div class="col-md-2">
                              </div>

                            <div class="col-md-2">

                              <span class="badge badge-pill " style="font-size: 15px;background-color: #fff; color: black;width:50px;">A</span>

                              <span class="badge badge-pill badge-danger" style="font-size: 16px;background-color: #2ecc71; color: white;width:50px;">{{a_findings}}</span>

                            </div>
                            <div class="col-md-2">
                              <span class="badge badge-pill" style="font-size: 15px;background-color: #fff;  color:black;width:50px;">B</span>
                              <span class="badge badge-pill badge-danger" style="font-size: 16px;background-color: #f1c40f; color: white;width:50px;">{{b_findings}}</span>
                            </div>
                            <div class="col-md-2">
                              <span class="badge badge-pill " style="font-size: 15px; background-color: #fff;color: black;width:50px;">C</span>
                              <span class="badge badge-pill badge-warning" style="font-size: 16px; background-color: #e67e22;color: white;width:50px;">{{c_findings}}</span>
                            </div>
                            <div class="col-md-2">
                              <span class="badge badge-pill " style="font-size: 15px; background-color: #fff; color: black;width:50px;">D</span>
                              <span class="badge badge-pill badge-danger" style="font-size: 16px; background-color: #e74c3c; color: white;width:50px;">{{d_findings}}</span>
                            </div>








                          </div>
                          <div class="row text-center" v-if="findings_type === 'Compliance Audit'">
                            <div class="col-md-1">
                              </div>

                            <div class="col-md-2">

                              <span class="badge badge-pill " style="font-size: 15px;background-color: #fff; color: black;width:50px;">A</span>

                              <span class="badge badge-pill badge-danger" style="font-size: 16px;background-color: #2ecc71; color: white;width:50px;">{{always_findings}}</span>

                            </div>
                            <div class="col-md-2">
                              <span class="badge badge-pill" style="font-size: 15px;background-color: #fff;  color:black;width:50px;">M</span>
                              <span class="badge badge-pill badge-danger" style="font-size: 16px;background-color: #f1c40f; color: white;width:50px;">{{mostly_findings}}</span>
                            </div>
                            <div class="col-md-2">
                              <span class="badge badge-pill " style="font-size: 15px; background-color: #fff;color: black;width:50px;">S</span>
                              <span class="badge badge-pill badge-warning" style="font-size: 16px; background-color: #e67e22;color: white;width:50px;">{{sometimes_findings}}</span>
                            </div>
                            <div class="col-md-2">
                              <span class="badge badge-pill " style="font-size: 15px; background-color: #fff; color: black;width:50px;">N</span>
                              <span class="badge badge-pill badge-danger" style="font-size: 16px; background-color: #e74c3c; color: white;width:50px;">{{never_findings}}</span>
                            </div>
                            <div class="col-md-2">
                              <span class="badge badge-pill " style="font-size: 15px; background-color: #fff; color: black;width:50px;">U</span>
                              <span class="badge badge-pill badge-danger" style="font-size: 16px; background-color: #7f8c8d; color: white;width:50px;">{{untested_findings}}</span>
                            </div>








                          </div>

                          <div class="row text-center" v-if="findings_type === 'Remedial Actions'">
                            <div class="col-md-2">
                              </div>

                            <div class="col-md-2">

                              <span class="badge badge-pill " style="font-size: 7px;background-color: #fff; color: black;width:50px;margin-left:-10px;">{{texts.implemented}}</span>

                              <span class="badge badge-pill badge-danger" style="font-size: 16px;background-color: #2ecc71; color: white;width:50px;">{{implemented_findings}}</span>

                            </div>
                            <div class="col-md-2">
                              <span class="badge badge-pill" style="font-size: 7px;background-color: #fff; color: black;width:50px;margin-left:-8px;">{{texts.in_progress}}</span>
                              <span class="badge badge-pill badge-danger" style="font-size: 16px;background-color: #f1c40f; color: white;width:50px;">{{in_progress_findings}}</span>
                            </div>
                            <div class="col-md-2">
                              <span class="badge badge-pill " style="font-size: 7px;background-color: #fff; color: black;width:50px;margin-left:-8px;">{{texts.not_started}}</span>
                              <span class="badge badge-pill badge-warning" style="font-size: 16px; background-color: #7f8c8d;color: white;width:50px;">{{not_started_findings}}</span>
                            </div>
                            <div class="col-md-2">
                              <span class="badge badge-pill " style="font-size: 7px;background-color: #fff; color: black;width:50px;margin-left:-10px;">{{texts.overdue}}</span>
                              <span class="badge badge-pill badge-danger" style="font-size: 16px; background-color: #e74c3c; color: white;width:50px;">{{overdue_findings}}</span>
                            </div>









                          </div>

                          <!-- <div class="row">
                            <span class="badge badge-pill " style="margin-left : 25px;font-size: 15px;background-color: #fff; color: black;margin-right: 1px;">V.H</span>
                            <span class="badge badge-pill" style="font-size: 15px;background-color: #fff; margin-right: 1px; color:black">H</span>
                            <span class="badge badge-pill " style="margin-left : 5px;font-size: 15px; background-color: #fff;color: black;margin-right: 1px;">M</span>
                            <span class="badge badge-pill " style="margin-left : 7px;font-size: 15px; background-color: #fff; color: black;">L</span>

                             <span class="badge badge-pill " style="margin-left : 5px;font-size: 15px;background-color: #fff; color: black;margin-right: 1px;">V.L</span>

                          </div>
                          <div>
                              <span class="badge badge-pill badge-danger" style="margin-left : 10px;font-size: 16px;background-color: #bf2718; color: white;margin-right: 1px;">{{very_high_findings}}</span>
                            <span class="badge badge-pill badge-danger" style="margin-left : 5px;font-size: 16px;background-color: #E74C3C; color: white;margin-right: 1px;">{{high_findings}}</span>
                            <span class="badge badge-pill badge-warning" style="margin-left : 5px;font-size: 16px; background-color: #F39C12;color: white;margin-right: 1px;">{{medium_findings}}</span>
                            <span class="badge badge-pill badge-danger" style="margin-left : 5px;font-size: 16px; background-color: #F4D03F; color: white;">{{low_findings}}</span>

                             <span class="badge badge-pill badge-danger" style="margin-left : 5px;font-size: 16px;background-color: #ffeb14; color: white;margin-right: 1px;">{{very_low_findings}}</span>
                          </div> -->
                          </center>

                                    <!--   </div>
                                  </div> -->

                                  <pie-chart v-if="loaded"
                                          :height="250"
                                          ref="pieChart"
                                          :chart-data="redBarChart.chartData"
                                  >
                                  </pie-chart>
                    </card>
                </div>

            </div>

            <!-- SECOND PIE CHART  -->
            <div class="row" style="margin-top:-435px;z-index:2;" v-if="has_remedial_actions">
              <div class="col-xl-7 mb-5 mb-xl-0" style="display:none;" :dir="language">
              </div>
              <div class="col-xl-5" style="margin-left : 58.5%" v-if="loaded && has_remedial_actions && language == 'ltr'" :dir="language">
                  <card header-classes="bg-transparent" style="height:411px;">
                    <h3 v-if="language == 'ltr'">Implementation Status</h3>
                    <h3 v-else style="text-align:right;">Implementation Status</h3>
                      <center>

                        <div class="row text-center" v-if="findings_type_two === 'Internal Audit'">
                          <div class="col-md-1">
                            </div>

                          <div class="col-md-2">


                            <span class="badge badge-pill " style="font-size: 15px;background-color: #fff; color: black;width:50px;">V.H</span>

                            <span class="badge badge-pill badge-danger" style="font-size: 16px;background-color: #bf2718; color: white;width:50px;">{{very_high_findings}}</span>

                          </div>
                          <div class="col-md-2">
                            <span class="badge badge-pill" style="font-size: 15px;background-color: #fff;  color:black;width:50px;">H</span>
                            <span class="badge badge-pill badge-danger" style="font-size: 16px;background-color: #E74C3C; color: white;width:50px;">{{high_findings}}</span>
                          </div>
                          <div class="col-md-2">
                            <span class="badge badge-pill " style="font-size: 15px; background-color: #fff;color: black;width:50px;">M</span>
                            <span class="badge badge-pill badge-warning" style="font-size: 16px; background-color: #F39C12;color: white;width:50px;">{{medium_findings}}</span>
                          </div>
                          <div class="col-md-2">
                            <span class="badge badge-pill " style="font-size: 15px; background-color: #fff; color: black;width:50px;">L</span>
                            <span class="badge badge-pill badge-danger" style="font-size: 16px; background-color: #F4D03F; color: white;width:50px;">{{low_findings}}</span>
                          </div>
                          <div class="col-md-2">
                            <span class="badge badge-pill " style="font-size: 15px;background-color: #fff; color: black;width:50px;">V.L</span>
                            <span class="badge badge-pill badge-danger" style="font-size: 16px;background-color: #2ecc71; color: white;width:50px;">{{very_low_findings}}</span>
                          </div>







                        </div>
                        <div class="row text-center" v-if="findings_type_two === 'Risk Assessment'">
                          <div class="col-md-2">
                            </div>

                          <div class="col-md-2">

                            <span class="badge badge-pill " style="font-size: 15px;background-color: #fff; color: black;width:50px;">A</span>

                            <span class="badge badge-pill badge-danger" style="font-size: 16px;background-color: #2ecc71; color: white;width:50px;">{{a_findings}}</span>

                          </div>
                          <div class="col-md-2">
                            <span class="badge badge-pill" style="font-size: 15px;background-color: #fff;  color:black;width:50px;">B</span>
                            <span class="badge badge-pill badge-danger" style="font-size: 16px;background-color: #f1c40f; color: white;width:50px;">{{b_findings}}</span>
                          </div>
                          <div class="col-md-2">
                            <span class="badge badge-pill " style="font-size: 15px; background-color: #fff;color: black;width:50px;">C</span>
                            <span class="badge badge-pill badge-warning" style="font-size: 16px; background-color: #e67e22;color: white;width:50px;">{{c_findings}}</span>
                          </div>
                          <div class="col-md-2">
                            <span class="badge badge-pill " style="font-size: 15px; background-color: #fff; color: black;width:50px;">D</span>
                            <span class="badge badge-pill badge-danger" style="font-size: 16px; background-color: #e74c3c; color: white;width:50px;">{{d_findings}}</span>
                          </div>








                        </div>
                        <div class="row text-center" v-if="findings_type_two === 'Compliance Audit'">
                          <div class="col-md-1">
                            </div>

                          <div class="col-md-2">

                            <span class="badge badge-pill " style="font-size: 15px;background-color: #fff; color: black;width:50px;">A</span>

                            <span class="badge badge-pill badge-danger" style="font-size: 16px;background-color: #2ecc71; color: white;width:50px;">{{always_findings}}</span>

                          </div>
                          <div class="col-md-2">
                            <span class="badge badge-pill" style="font-size: 15px;background-color: #fff;  color:black;width:50px;">M</span>
                            <span class="badge badge-pill badge-danger" style="font-size: 16px;background-color: #f1c40f; color: white;width:50px;">{{mostly_findings}}</span>
                          </div>
                          <div class="col-md-2">
                            <span class="badge badge-pill " style="font-size: 15px; background-color: #fff;color: black;width:50px;">S</span>
                            <span class="badge badge-pill badge-warning" style="font-size: 16px; background-color: #e67e22;color: white;width:50px;">{{sometimes_findings}}</span>
                          </div>
                          <div class="col-md-2">
                            <span class="badge badge-pill " style="font-size: 15px; background-color: #fff; color: black;width:50px;">N</span>
                            <span class="badge badge-pill badge-danger" style="font-size: 16px; background-color: #e74c3c; color: white;width:50px;">{{never_findings}}</span>
                          </div>
                          <div class="col-md-2">
                            <span class="badge badge-pill " style="font-size: 15px; background-color: #fff; color: black;width:50px;">U</span>
                            <span class="badge badge-pill badge-danger" style="font-size: 16px; background-color: #7f8c8d; color: white;width:50px;">{{untested_findings}}</span>
                          </div>








                        </div>

                        <div class="row text-center" v-if="findings_type_two === 'Remedial Actions'">
                          <div class="col-md-2">
                            </div>

                          <div class="col-md-2">

                            <span class="badge badge-pill " style="font-size: 7px;background-color: #fff; color: black;width:50px;margin-left:-10px;">Implemented</span>

                            <span class="badge badge-pill badge-danger" style="font-size: 16px;background-color: #2ecc71; color: white;width:50px;">{{implemented_findings}}</span>

                          </div>
                          <div class="col-md-2">
                            <span class="badge badge-pill" style="font-size: 7px;background-color: #fff;  color:black;width:50px;margin-left:-8px;">In Progress</span>
                            <span class="badge badge-pill badge-danger" style="font-size: 16px;background-color: #f1c40f; color: white;width:50px;">{{in_progress_findings}}</span>
                          </div>
                          <div class="col-md-2">
                            <span class="badge badge-pill " style="font-size: 7px; background-color: #fff;color: black;width:50px;margin-left:-8px;">Not Started</span>
                            <span class="badge badge-pill badge-warning" style="font-size: 16px; background-color: #7f8c8d;color: white;width:50px;">{{not_started_findings}}</span>
                          </div>
                          <div class="col-md-2">
                            <span class="badge badge-pill " style="font-size: 7px; background-color: #fff; color: black;width:50px;margin-left:0px;">Overdue</span>
                            <span class="badge badge-pill badge-danger" style="font-size: 16px; background-color: #e74c3c; color: white;width:50px;">{{overdue_findings}}</span>
                          </div>









                        </div>

                        <!-- <div class="row">
                          <span class="badge badge-pill " style="margin-left : 25px;font-size: 15px;background-color: #fff; color: black;margin-right: 1px;">V.H</span>
                          <span class="badge badge-pill" style="font-size: 15px;background-color: #fff; margin-right: 1px; color:black">H</span>
                          <span class="badge badge-pill " style="margin-left : 5px;font-size: 15px; background-color: #fff;color: black;margin-right: 1px;">M</span>
                          <span class="badge badge-pill " style="margin-left : 7px;font-size: 15px; background-color: #fff; color: black;">L</span>

                           <span class="badge badge-pill " style="margin-left : 5px;font-size: 15px;background-color: #fff; color: black;margin-right: 1px;">V.L</span>

                        </div>
                        <div>
                            <span class="badge badge-pill badge-danger" style="margin-left : 10px;font-size: 16px;background-color: #bf2718; color: white;margin-right: 1px;">{{very_high_findings}}</span>
                          <span class="badge badge-pill badge-danger" style="margin-left : 5px;font-size: 16px;background-color: #E74C3C; color: white;margin-right: 1px;">{{high_findings}}</span>
                          <span class="badge badge-pill badge-warning" style="margin-left : 5px;font-size: 16px; background-color: #F39C12;color: white;margin-right: 1px;">{{medium_findings}}</span>
                          <span class="badge badge-pill badge-danger" style="margin-left : 5px;font-size: 16px; background-color: #F4D03F; color: white;">{{low_findings}}</span>

                           <span class="badge badge-pill badge-danger" style="margin-left : 5px;font-size: 16px;background-color: #ffeb14; color: white;margin-right: 1px;">{{very_low_findings}}</span>
                        </div> -->
                        </center>

                                  <!--   </div>
                                </div> -->

                                <pie-chart v-if="loaded"
                                        :height="250"
                                        ref="pieChart"
                                        :chart-data="remedialBarChart.chartData"
                                >
                                </pie-chart>
                  </card>
              </div>
              <div class="col-xl-5" style="margin-right : 58.5%" v-else :dir="language">
                  <card header-classes="bg-transparent" style="height:411px;">
                    <h3 v-if="language == 'ltr'">Implementation Status</h3>
                    <h3 v-else style="text-align:right;">وضع تطبيق التوصيات</h3>
                      <center>

                        <div class="row text-center" v-if="findings_type_two === 'Internal Audit'">
                          <div class="col-md-1">
                            </div>

                          <div class="col-md-2">


                            <span class="badge badge-pill " style="font-size: 15px;background-color: #fff; color: black;width:50px;">V.H</span>

                            <span class="badge badge-pill badge-danger" style="font-size: 16px;background-color: #bf2718; color: white;width:50px;">{{very_high_findings}}</span>

                          </div>
                          <div class="col-md-2">
                            <span class="badge badge-pill" style="font-size: 15px;background-color: #fff;  color:black;width:50px;">H</span>
                            <span class="badge badge-pill badge-danger" style="font-size: 16px;background-color: #E74C3C; color: white;width:50px;">{{high_findings}}</span>
                          </div>
                          <div class="col-md-2">
                            <span class="badge badge-pill " style="font-size: 15px; background-color: #fff;color: black;width:50px;">M</span>
                            <span class="badge badge-pill badge-warning" style="font-size: 16px; background-color: #F39C12;color: white;width:50px;">{{medium_findings}}</span>
                          </div>
                          <div class="col-md-2">
                            <span class="badge badge-pill " style="font-size: 15px; background-color: #fff; color: black;width:50px;">L</span>
                            <span class="badge badge-pill badge-danger" style="font-size: 16px; background-color: #F4D03F; color: white;width:50px;">{{low_findings}}</span>
                          </div>
                          <div class="col-md-2">
                            <span class="badge badge-pill " style="font-size: 15px;background-color: #fff; color: black;width:50px;">V.L</span>
                            <span class="badge badge-pill badge-danger" style="font-size: 16px;background-color: #2ecc71; color: white;width:50px;">{{very_low_findings}}</span>
                          </div>







                        </div>
                        <div class="row text-center" v-if="findings_type_two === 'Risk Assessment'">
                          <div class="col-md-2">
                            </div>

                          <div class="col-md-2">

                            <span class="badge badge-pill " style="font-size: 15px;background-color: #fff; color: black;width:50px;">A</span>

                            <span class="badge badge-pill badge-danger" style="font-size: 16px;background-color: #2ecc71; color: white;width:50px;">{{a_findings}}</span>

                          </div>
                          <div class="col-md-2">
                            <span class="badge badge-pill" style="font-size: 15px;background-color: #fff;  color:black;width:50px;">B</span>
                            <span class="badge badge-pill badge-danger" style="font-size: 16px;background-color: #f1c40f; color: white;width:50px;">{{b_findings}}</span>
                          </div>
                          <div class="col-md-2">
                            <span class="badge badge-pill " style="font-size: 15px; background-color: #fff;color: black;width:50px;">C</span>
                            <span class="badge badge-pill badge-warning" style="font-size: 16px; background-color: #e67e22;color: white;width:50px;">{{c_findings}}</span>
                          </div>
                          <div class="col-md-2">
                            <span class="badge badge-pill " style="font-size: 15px; background-color: #fff; color: black;width:50px;">D</span>
                            <span class="badge badge-pill badge-danger" style="font-size: 16px; background-color: #e74c3c; color: white;width:50px;">{{d_findings}}</span>
                          </div>








                        </div>
                        <div class="row text-center" v-if="findings_type_two === 'Compliance Audit'">
                          <div class="col-md-1">
                            </div>

                          <div class="col-md-2">

                            <span class="badge badge-pill " style="font-size: 15px;background-color: #fff; color: black;width:50px;">A</span>

                            <span class="badge badge-pill badge-danger" style="font-size: 16px;background-color: #2ecc71; color: white;width:50px;">{{always_findings}}</span>

                          </div>
                          <div class="col-md-2">
                            <span class="badge badge-pill" style="font-size: 15px;background-color: #fff;  color:black;width:50px;">M</span>
                            <span class="badge badge-pill badge-danger" style="font-size: 16px;background-color: #f1c40f; color: white;width:50px;">{{mostly_findings}}</span>
                          </div>
                          <div class="col-md-2">
                            <span class="badge badge-pill " style="font-size: 15px; background-color: #fff;color: black;width:50px;">S</span>
                            <span class="badge badge-pill badge-warning" style="font-size: 16px; background-color: #e67e22;color: white;width:50px;">{{sometimes_findings}}</span>
                          </div>
                          <div class="col-md-2">
                            <span class="badge badge-pill " style="font-size: 15px; background-color: #fff; color: black;width:50px;">N</span>
                            <span class="badge badge-pill badge-danger" style="font-size: 16px; background-color: #e74c3c; color: white;width:50px;">{{never_findings}}</span>
                          </div>
                          <div class="col-md-2">
                            <span class="badge badge-pill " style="font-size: 15px; background-color: #fff; color: black;width:50px;">U</span>
                            <span class="badge badge-pill badge-danger" style="font-size: 16px; background-color: #7f8c8d; color: white;width:50px;">{{untested_findings}}</span>
                          </div>








                        </div>

                        <div class="row text-center" v-if="findings_type_two === 'Remedial Actions'">
                          <div class="col-md-2">
                            </div>

                          <div class="col-md-2">

                            <span class="badge badge-pill " style="font-size: 10px;background-color: #fff; color: black;width:50px;margin-left:-10px;">نفذت</span>

                            <span class="badge badge-pill badge-danger" style="font-size: 16px;background-color: #2ecc71; color: white;width:50px;">{{implemented_findings}}</span>

                          </div>
                          <div class="col-md-2">
                            <span class="badge badge-pill" style="font-size: 10px;background-color: #fff; color: black;width:50px;margin-left:-4px;">تحت التنفيذ</span>
                            <span class="badge badge-pill badge-danger" style="font-size: 16px;background-color: #f1c40f; color: white;width:50px;">{{in_progress_findings}}</span>
                          </div>
                          <div class="col-md-2">
                            <span class="badge badge-pill " style="font-size: 10px;background-color: #fff; color: black;width:50px;margin-left:-8px;">لم تبدأ</span>
                            <span class="badge badge-pill badge-warning" style="font-size: 16px; background-color: #7f8c8d;color: white;width:50px;">{{not_started_findings}}</span>
                          </div>
                          <div class="col-md-2">
                            <span class="badge badge-pill " style="font-size: 10px;background-color: #fff; color: black;width:50px;margin-left:-10px;">متأخرة</span>
                            <span class="badge badge-pill badge-danger" style="font-size: 16px; background-color: #e74c3c; color: white;width:50px;">{{overdue_findings}}</span>
                          </div>









                        </div>

                        <!-- <div class="row">
                          <span class="badge badge-pill " style="margin-left : 25px;font-size: 15px;background-color: #fff; color: black;margin-right: 1px;">V.H</span>
                          <span class="badge badge-pill" style="font-size: 15px;background-color: #fff; margin-right: 1px; color:black">H</span>
                          <span class="badge badge-pill " style="margin-left : 5px;font-size: 15px; background-color: #fff;color: black;margin-right: 1px;">M</span>
                          <span class="badge badge-pill " style="margin-left : 7px;font-size: 15px; background-color: #fff; color: black;">L</span>

                           <span class="badge badge-pill " style="margin-left : 5px;font-size: 15px;background-color: #fff; color: black;margin-right: 1px;">V.L</span>

                        </div>
                        <div>
                            <span class="badge badge-pill badge-danger" style="margin-left : 10px;font-size: 16px;background-color: #bf2718; color: white;margin-right: 1px;">{{very_high_findings}}</span>
                          <span class="badge badge-pill badge-danger" style="margin-left : 5px;font-size: 16px;background-color: #E74C3C; color: white;margin-right: 1px;">{{high_findings}}</span>
                          <span class="badge badge-pill badge-warning" style="margin-left : 5px;font-size: 16px; background-color: #F39C12;color: white;margin-right: 1px;">{{medium_findings}}</span>
                          <span class="badge badge-pill badge-danger" style="margin-left : 5px;font-size: 16px; background-color: #F4D03F; color: white;">{{low_findings}}</span>

                           <span class="badge badge-pill badge-danger" style="margin-left : 5px;font-size: 16px;background-color: #ffeb14; color: white;margin-right: 1px;">{{very_low_findings}}</span>
                        </div> -->
                        </center>

                                  <!--   </div>
                                </div> -->

                                <pie-chart v-if="loaded"
                                        :height="250"
                                        ref="pieChart"
                                        :chart-data="remedialBarChart.chartData"
                                >
                                </pie-chart>
                  </card>
              </div>
            </div>


            <!-- End charts

            <!--Tables-->
           <!--  <div class="row mt-5">
                <div class="col-xl-8 mb-5 mb-xl-0">
                    <page-visits-table></page-visits-table>
                </div>
                <div class="col-xl-4">
                    <social-traffic-table></social-traffic-table>
                </div>
            </div> -->
            <!--End tables-->
        </div>

        <!-- <div style="z-index: 1;position: relative;">
          <base-button class="btn-primary"  icon="ni ni-chat-round" style='position: fixed;bottom: 27px;right: 15px;height:44px;border-radius:50px;font-size:15px;background-color: rgb(79, 47, 129);' v-on:click="openChatModal">{{texts.chats}}</base-button>
        </div> -->
         <!-- <div>

          <beautiful-chat style="z-index: 1;position: relative;" v-if="isChatHidden" id="chat"
            :participants="participants"
            :titleImageUrl="titleImageUrl"
            :onMessageWasSent="onMessageWasSent"
            :messageList="messageList"
            :newMessagesCount="newMessagesCount"
            :isOpen="isChatOpen"
            :close="closeChat"
            :icons="icons"
            :open="openChat"
            :showEmoji="true"
            :showFile="false"
            :showTypingIndicator="showTypingIndicator"
            :colors="colors"
            :alwaysScrollToBottom="alwaysScrollToBottom"
            :messageStyling="messageStyling"
            v-on:onType="handleOnType"
            v-on:edit="editMessage" />
        </div> -->
        <modal id="chatsModal" :show.sync="modals.modal9" dir="ltr">
        <template slot="header">
           <span style="font-size: 24px; color: black;" id="exampleModalLabel">{{texts.chats}}</span>
        </template>
          <div style="overflow-y: scroll; height:400px;">
          <card v-for="chat in chats" header-classes="bg-white" style="background-color: white;background: #fff;" >
            <div class="row">
              <div v-if="true" class="col-1" style="margin-top:-12px;">
              <badge v-if="chat.notifications > 0" type="danger" style="background:red;color:#fff;font-size: 14px;border-radius:50px;width:26px;height:26px;margin-left:-10px;">{{chat.notifications}}</badge>
              </div>

              <h2 class="col-7" style="margin-top:-10px;">{{chat.title}}</h2><div class="col-4"  style="width: 100%; margin-top:-15px;">

              <button type="button" style="float: right;margin-top: 10px;" class="btn btn-primary" v-on:click="onClickChat(chat)">{{texts.view}}</button>

                </div>
              <!-- <br> -->
              <span class="col-8" style="font-size:16px;">{{chat.message.data.text}}</span>
              <br>
              <br>
              <span class="col-8" style="font-size:12px;">Received : {{chat.message.data.meta}}</span>

              <span class="col-8" style="margin-top:15px;margin-left:-6px;margin-bottom:-6px;"><badge type="primary" style="margin-left: 5px;border-radius:50px;">{{chat.participantsDisplay}}</badge></span>
            </div>
          </card>



        </div>
        <template slot="footer" style="justify-content:centered;">
            <base-button type="primary"  icon="ni ni-fat-add" style="font-size:13px;border-radius:50px;" @click="newPublicChat()">{{texts.publicchat}}</base-button>
            <base-button type="info" icon="ni ni-fat-add" style="font-size:13px;border-radius:50px;"  @click="newPrivateChat()">{{texts.privatechat}}</base-button>
            <base-button type="secondary" @click="modals.modal9 = false" style="margin-left:50px;">{{texts.close}}</base-button>
        </template>
        </modal>

<div>
          <!-- <beautiful-chat
            :participants="participants"
            :titleImageUrl="titleImageUrl"
            :onMessageWasSent="onMessageWasSent"
            :messageList="messageList"
            :newMessagesCount="newMessagesCount"
            :isOpen="isChatOpen"
            :close="closeChat"
            :icons="icons"
            :open="openChat"
            :showEmoji="true"
            :showFile="true"
            :showTypingIndicator="showTypingIndicator"
            :colors="colors"
            :alwaysScrollToBottom="alwaysScrollToBottom"
            :messageStyling="messageStyling"
            v-on:onType="handleOnType"
            v-on:edit="editMessage" /> -->
        </div>

    </div>

</template>
<script>
    import { mapState } from "vuex";
  import { GET_DELIVERABLES,CREATE_CHAT, GET_CHATS, SEND_MESSAGE } from "@/store/actions.type";
  import store from "@/store";
  import Vue from 'vue'
  import VueClipboard from 'vue-clipboard2'
  import BTooltipDirective from 'bootstrap-vue/es/directives/tooltip'
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import PDFObject from 'pdfobject';
  import FullCalendar from '@fullcalendar/vue'
  import PieChart from '@/components/Charts/PieChart';
  import dayGridPlugin from '@fullcalendar/daygrid'
  import CloseIcon from 'vue-beautiful-chat/src/assets/close-icon.png'
  import OpenIcon from 'vue-beautiful-chat/src/assets/logo-no-bg.svg'
  import FileIcon from 'vue-beautiful-chat/src/assets/file.svg'
  import CloseIconSvg from 'vue-beautiful-chat/src/assets/close.svg'
  import { mapGetters } from "vuex";
  import UserService from "@/common/user.service";
  import JwtService from "@/common/jwt.service";

  Vue.use(VueClipboard)
  export default {
    directives: {
      'b-tooltip': BTooltipDirective
    },
    components: {flatPicker, FullCalendar,PieChart},
    data() {
      return {
        texts : {
          back : UserService.getLanguage() === "rtl" ? "رجوع" : "Back",
          deliverables : UserService.getLanguage() === "rtl" ? "المخرجات" : "Deliverables",
          view : UserService.getLanguage() === "rtl" ? "عرض" : "View Report",
          findings : UserService.getLanguage() === "rtl" ? "النتائج" : "Results",
          register : UserService.getLanguage() === "rtl" ? "تسجيل" : "Register",
          phonenumber : UserService.getLanguage() === "rtl" ? "رقم الهاتف" : "Phone Number",
          title : UserService.getLanguage() === "rtl" ? "المسمى الوظيفي" : "Title",
          newpass : UserService.getLanguage() === "rtl" ? "كلمة السر الجديدة" : "New Password",
          close : UserService.getLanguage() === "rtl" ? "إغلاق" : "Close",
          chats : UserService.getLanguage() === "rtl" ? ".  محادثات" : "Chats",
          view : UserService.getLanguage() === "rtl" ? "عرض التقرير" : "View Report",
          publicchat : UserService.getLanguage() === "rtl" ? "محادثة عامة" : "Public Chat",
          privatechat : UserService.getLanguage() === "rtl" ? "محادثة خاصة" : "Private Chat",
          edit : UserService.getLanguage() === "rtl" ? "تعديل" : "Edit",
          very_low : UserService.getLanguage() === "ltr" ? "V. L." : "متدني للغاية",
          low : UserService.getLanguage() === "ltr" ? "L" : "متدني",
          medium : UserService.getLanguage() === "ltr" ? "M" : "متوسط",
          high : UserService.getLanguage() === "ltr" ? "H" : "مرتفع",
          very_high : UserService.getLanguage() === "ltr" ? "V. H." : "مرتفع جدا",
          implemented : UserService.getLanguage() === "ltr" ? "Implemented" : "نفذت",
          in_progress : UserService.getLanguage() === "ltr" ? "In Progress" : "قيد التنفيذ",
          overdue : UserService.getLanguage() === "ltr" ? "Overdue" : "متأخر",
          not_started : UserService.getLanguage() === "ltr" ? "Not Started" : "لم تبدأ",
        },
        isManager :JwtService.getIsManager() === 1,
        language : UserService.getLanguage() || "ltr",
        isChatHidden : true,
        chats : [],
        isNewChat : false,
        chatId : "",
        chatType : "",
        chatTitle : "",
        modals : {
          modal9 : false
        },

      calendarPlugins: [ dayGridPlugin ],

        graph_text : "",
        loaded : false,
        title : '',
        deliverables : [],
        percentages : [],
        very_high_findings : 0,
        high_findings : 0,
          medium_findings :0,
          low_findings : 0,
          very_low_findings : 0,
          a_findings : 0,
          b_findings : 0,
          c_findings : 0,
          d_findings : 0,
          implemented_findings : 0,
          in_progress_findings : 0,
          not_started_findings : 0,
          overdue_findings : 0,
          always_findings : 0,
          mostly_findings : 0,
          sometimes_findings : 0,
          never_findings : 0,
          untested_findings : 0,
          findings_type : "",
          findings_type_two : "",
          total_findings : String(10),
          current_date : 1,
          has_remedial_actions : false,
           date_1 : "February 11, 2019",
          date_2 : "February 11, 2019",
          date_3 : "May 24, 2019",
          date_4 : "May 29, 2019",
          redBarChart: {
          chartData: {
            labels: [],
            datasets: [{
                backgroundColor: [],
              data: [],//store.getters.percentagesArray,
            }]
          }
        },

        remedialBarChart: {
        chartData: {
          labels: [],
          datasets: [{
              backgroundColor: [],
            data: [],//store.getters.percentagesArray,
          }]
        }
      },
              icons:{
        open:{
          img: OpenIcon,
          name: 'default',
        },
        close:{
          img: CloseIcon,
          name: 'default',
        },
        file:{
          img: FileIcon,
          name: 'default',
        },
        closeSvg:{
          img: CloseIconSvg,
          name: 'default',
        },
      },
      participants: [
        // {
        //   id: 'user1',
        //   name: 'Othman Barakat',
        //   imageUrl: 'https://avatars3.githubusercontent.com/u/1915989?s=230&v=4'
        // },
        // {
        //   id: 'user2',
        //   name: 'Nasser Barakat',
        //   imageUrl: 'https://avatars3.githubusercontent.com/u/1915989?s=230&v=4'
        // }
      ], // the list of all the participant of the conversation. `name` is the user name, `id` is used to establish the author of a message, `imageUrl` is supposed to be the user avatar.
      titleImageUrl: 'https://a.slack-edge.com/66f9/img/avatars-teams/ava_0001-34.png',
      messageList: [
          // { type: 'text', author: `me`, data: { text: `Regarding the risk assessment report for phase 1, why is there a lack of documentation about the reported case on page 4 ?`,  meta: '06-16-2019 12:43' } },
          // { type: 'text', author: `user1`, data: { text: `Dear Mr. Ahmad, we have looked into your enquiry and found that indeed there was a lack of documentation. We shall update the report.` } }
      ], // the list of the messages to show, can be paginated and adjusted dynamically
      suggestions: ['some quick reply', 'another one'],
      newMessagesCount: 0,
      isChatOpen: false, // to determine whether the chat window should be open or closed
      showTypingIndicator: '', // when set to a value matching the participant.id it shows the typing indicator for the specific user
      colors: {
        header: {
          bg: '#4f2f81',
          text: '#ffffff'
        },
        launcher: {
          bg: '#4f2f81'
        },
        messageList: {
          bg: '#ffffff'
        },
        sentMessage: {
          bg: '#4f2f81',
          text: '#ffffff'
        },
        receivedMessage: {
          bg: '#eaeaea',
          text: '#222222'
        },
        userInput: {
          bg: '#f4f7f9',
          text: '#565867'
        }
      }, // specifies the color scheme for the component
      alwaysScrollToBottom: false, // when set to true always scrolls the chat to the bottom when new events are in (new message, user starts typing...)
      messageStyling: true

      }
    },
     computed: {
        ...mapGetters(["isAuthenticated", "percentagesArray"])
        // ,
        // subscribers() {
        //     console.log(this.$route.params.subscribers);
        //   return this.$route.params.subscribers;
        // }
      },
    methods: {
      back() {
        window.history.back();
        // this.$router.push({ name: 'sendsms' });
      },
      newPublicChat() {
        this.modals.modal9 = false;
        if (Number(this.chats.length) === 0) {
          this.isNewChat = true;
          this.chatType = "public";
          document.getElementById("chat").style.visibility = "visible";
          this.openChat();
          this.chatTitle = "Public Inquiry";
          document.getElementsByClassName("sc-header--title enabled")[0].innerHTML = "Public Inquiry";
        }
        else {
          this.isNewChat = false;
          this.chatType = "public";
          document.getElementById("chat").style.visibility = "visible";
          let isChatFound = false;
          for (let i = 0 ; i < this.chats.length; i++) {
            console.log(this.chats[i]);
              if (this.chats[i].type === "public") {
                this.messageList = this.chats[i].messages;
                this.chatId = this.chats[i].id;
                this.participants = this.chats[i].participants;
                isChatFound = true;
                break;
              }
          }
          if (!isChatFound) {
            this.messageList = [];
            this.chatId = "";
            this.participants = [];
          }
          this.openChat();
          this.chatTitle = "Public Inquiry";
          document.getElementsByClassName("sc-header--title enabled")[0].innerHTML = "Public Inquiry";
        }
      },
      newPrivateChat() {
        this.modals.modal9 = false;
        if (Number(this.chats.length) === 0) {
          this.isNewChat = true;
          this.chatType = "private";
          document.getElementById("chat").style.visibility = "visible";
          this.openChat();
          this.chatTitle = "Private Inquiry";
          document.getElementsByClassName("sc-header--title enabled")[0].innerHTML = "Private Inquiry";
        }
        else {
          this.isNewChat = false;
          this.chatType = "private";
          document.getElementById("chat").style.visibility = "visible";
          let isChatFound = false;
          for (let i = 0 ; i < this.chats.length; i++) {
              if (this.chats[i].type === "private") {
                this.messageList = this.chats[i].messages;
                this.chatId = this.chats[i].id;
                this.participants = this.chats[i].participants;
                isChatFound = true;
                break;
              }
          }
          if (!isChatFound) {
            this.messageList = [];
            this.chatId = "";
            this.participants = [];
          }

          this.openChat();
          this.chatTitle = "Private Inquiry";
          document.getElementsByClassName("sc-header--title enabled")[0].innerHTML = "Private Inquiry";
        }
      },
      onClickChat(chat) {
        // this.isChatHidden = true;

        // document.getElementById("chatsModal").childNodes[0].childNodes[0].style = 'background-color: #ffffff;opacity: 0.0;';
        this.modals.modal9 = false;
        this.messageList = chat.messages;
        this.chatId = chat.id;
        this.participants = chat.participants;
        // this.chatType = chat.type;
        console.log(chat);
        document.getElementsByClassName("sc-header--title enabled")[0].innerHTML = chat.title;
        document.getElementById("chat").style.visibility = "visible";


        this.openChat();
      },
      openChatModal() {
        if (this.modals.modal9) {
          this.modals.modal9 = false;
        }
        else {

          Promise.all([
            store.dispatch(GET_CHATS)
          ]).then((data) => {
            console.log(data[0]['data']);
              if (data[0]['data']) {
                  this.chats = data[0]['data'];
              }
              else {
                this.chats = [];
              }

              this.modals.modal9 = true;

          });

        }
      },
      sendMessage (text) {
        let formData = {'assignment_id' : UserService.getAssignmentId(), 'title' : this.chatTitle, 'text' : text, 'chat_type' : this.chatType};
        console.log(formData);
        console.log(CREATE_CHAT);
      if (text.length > 0) {
        if (this.isNewChat) {
          let formData = {'assignment_id' : UserService.getAssignmentId(), 'title' : this.chatTitle, 'text' : text, 'chat_type' : this.chatType};
          console.log(formData);
          console.log(CREATE_CHAT);
          Promise.all([
            store.dispatch(CREATE_CHAT, formData)
          ]).then(() => {
            this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1
            // this.onMessageWasSent({ author: 'support', type: 'text', data: { text } });
          });
        }
        else {
          // Promise.all([
          //   store.dispatch(GET_OVERVIEW, "5e03d4c5c060d91d3c228b2a")
          // ]).then(() => {
          //   this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1
          //   this.onMessageWasSent({ author: 'support', type: 'text', data: { text } });
          // });
        }

      }
    },
    onMessageWasSent (message) {
      let canSend = (this.userType === "team" && JwtService.getIsManager() === 1) || (this.userType === "committee");
      if (canSend) {
        console.log(message);
        message.author = UserService.getUserId();
        // called when the user sends a message

        let formData = {'assignment_id' : UserService.getAssignmentId(), 'title' : this.chatTitle, 'text' : message.data.text, 'chat_type' : this.chatType};
        console.log(formData);
        console.log(CREATE_CHAT);
        if (message.data.text.length > 0) {
        if (this.isNewChat) {
          let formData = {'assignment_id' : UserService.getAssignmentId(), 'title' : this.chatTitle, 'text' : message.data.text, 'chat_type' : this.chatType};
          console.log(formData);
          console.log(CREATE_CHAT);
          Promise.all([
            store.dispatch(CREATE_CHAT, formData)
          ]).then((data) => {
            this.chatId = data[0]['chatId'];
            this.isNewChat = false;
            this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1
            message.author = "me";
            this.messageList = [ ...this.messageList, message ]
            // this.onMessageWasSent({ author: 'support', type: 'text', data: { text } });
          });
        }
        else {
          message.author = UserService.getUserId();
          let formData = {'assignment_id' : UserService.getAssignmentId(), 'chat_id' : this.chatId,  'text' : message.data.text, 'chat_type' : this.chatType};
          console.log(formData);
          console.log(SEND_MESSAGE);
          Promise.all([
            store.dispatch(SEND_MESSAGE, formData)
          ]).then(() => {
            this.isNewChat = false;
            this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1
            message.author = "me";
            this.messageList = [ ...this.messageList, message ]
            // this.onMessageWasSent({ author: 'support', type: 'text', data: { text } });
          });
          // Promise.all([
          //   store.dispatch(GET_OVERVIEW, "5e03d4c5c060d91d3c228b2a")
          // ]).then(() => {
          //   this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1
          //   this.onMessageWasSent({ author: 'support', type: 'text', data: { text } });
          // });
        }

        }
      }

    },
    openChat () {
      // called when the user clicks on the fab button to open the chat
      this.isChatOpen = true
      this.newMessagesCount = 0

      // document.getElementById("chat").childNodes[1].style['margin-right'] = '100px';
      // if (document.getElementById("chat").childNodes[1].childNodes) {
      //   console.log("FOUND CHILD NODES");
      //   // console.log(document.getElementById("chat").childNodes[1].childNodes);
      //   for (let i =0 ; i < document.getElementById("chat").childNodes[1].childNodes.length; i++) {
      //     // console.log(document.getElementById("chat").childNodes[1].childNodes[i]);
      //     if (i == 1) {
      //       console.log(document.getElementById("chat").childNodes[1].childNodes[i]);
      //       for (let g = 0; g < document.getElementById("chat").childNodes[1].childNodes[i].childNodes.length; g++) {
      //         document.getElementById("chat").childNodes[1].childNodes[i].childNodes[g].style = 'margin-right : 100px';
      //       }
      //
      //     }
      //     if (document.getElementById("chat").childNodes[1].childNodes[i].style) {
      //         document.getElementById("chat").childNodes[1].childNodes[i].style['margin-right'] = '100px';
      //     }
      //     else {
      //       document.getElementById("chat").childNodes[1].childNodes[i].style = 'margin-right : 100px';
      //     }
      //
      //   }
      // }
      // else {
      //   console.log("NO CHILD NODES");
      // }
    },
    closeChat () {
      // called when the user clicks on the botton to close the chat
      this.isChatOpen = false
    },
    handleScrollToTop () {
      // called when the user scrolls message list to top
      // leverage pagination for loading another page of messages
    },
    handleOnType () {
      console.log('Emit typing event')
    },
    editMessage(message){
      const m = this.messageList.find(m=>m.id === message.id);
      m.isEdited = true;
      m.data.text = message.data.text;
    },
      onSubmit() {
        // console.log("TITLE : " + this.title);
        // console.log("MESSAGE : " + this.message);
        // console.log("TIMESLOT : " + this.timeslot);
        // console.log("TIERS : ");
        // console.log(this.tiers);
        // console.log("DATE : " + this.dates.simple);
            if (this.phone_no !== '' && this.name !== '') {
                this.localerrors = null;


                let formData = {'name' : this.name, 'phone_no':this.phone_no};
                console.log(formData);
                Promise.all([
                  store.dispatch(SEND_SMS, formData),

                ]).then(() => {
                    this.isLoading = false;
                    this.$router.push({ name: "overview" })
                });
            }
            else {

              this.localerrors = "Name and Phone cannot be empty !"

            }

          // this.$store
          //   .dispatch(LOGIN, { email, password })
          //   .then(() => this.$router.push({ name: "dashboard" }));
        },
      onChange(event) {
          this.timeslot = event.target.value;
          console.log(event);
      },
      onCopy() {
        this.$notify({
          type: 'success',
          title: 'Copied to clipboard'
        })
      },
       // onClick(token) {
       onClick(deliverable) {
         let token = this.$route.params.token;
          this.$router.push({ name: 'deliverable', params: { token:  deliverable._id, entity: token, phase:this.$route.params.phase} });
        },
        editDeliverable(deliverable) {
          let token = this.$route.params.token;
           this.$router.push({ name: 'editdeliverable', params: { token:  deliverable._id} });
         }
    },
    mounted() {
      // document.getElementById("chatsModal").childNodes[0].style = 'margin-right : 75px;background-color: #ffffff;';
      // document.getElementById("chat").style.visibility = "hidden";
      // document.getElementById("chat").childNodes[0].style="margin-right:125px;background-color: rgb(79, 47, 129);";
      // document.getElementById("chat").childNodes[0].childNodes[0].style="margin-right:125px;";
      // document.getElementById("chat").childNodes[0].childNodes[1].style="margin-right:125px;";
      //
      // if (this.userType === "committee") {
      //   this.participants = [{"id" : "1234", "name" : "AIGC Team", "imageUrl" : "https://cdn.iconscout.com/icon/free/png-256/user-avatar-contact-portfolio-personal-portrait-profile-6-5623.png"}];
      // }
      // else {
      //   this.participants = [{"id" : "1234", "name" : "Committee Members", "imageUrl" : "https://cdn.iconscout.com/icon/free/png-256/user-avatar-contact-portfolio-personal-portrait-profile-6-5623.png"}];
      // }

      this.loaded = false;
      Promise.all([
        store.dispatch(GET_DELIVERABLES, [this.$route.params.token, this.$route.params.phase])
      ]).then((data) => {

        console.log(data[0]['data']);
          this.deliverables = data[0]['data']['deliverables'];
          this.findings_type = String(data[0]['data']['findings_type']);

          console.log("FINDINGS TYPE");
          console.log(String(data[0]['data']['findings_type']));

          if (String(data[0]['data']['findings_type']) === "Internal Audit") {
            this.graph_text = UserService.getLanguage() === "ltr" ? "Findings Severity" : "أهمية الملاحظات";
            this.very_high_findings = data[0]['data']['very_high_findings'];
            this.high_findings = data[0]['data']['high_findings'];
            this.medium_findings = data[0]['data']['medium_findings'];
            this.low_findings = data[0]['data']['low_findings'];
            this.very_low_findings = data[0]['data']['very_low_findings'];
            this.redBarChart.chartData.labels = ["Very High %", "High %", "Medium %", "Low %", "Very Low %"];
            this.redBarChart.chartData.datasets[0].backgroundColor = ["#bf2718", "#E74C3C", "#F39C12", "#F4D03F", "#2ecc71"];
            this.percentages = data[0]['data']['percentages'];
            this.redBarChart.chartData.datasets[0].data = data[0]['data']['percentages'];
            this.loaded = true;
          }
          else if (String(data[0]['data']['findings_type']) === "Risk Assessment") {
            this.graph_text = UserService.getLanguage() === "ltr" ? "Control Environment Status" : "وضع البيئة الرقابية";
            this.a_findings = data[0]['data']['a_findings'];
            this.b_findings = data[0]['data']['b_findings'];
            this.c_findings = data[0]['data']['c_findings'];
            this.d_findings = data[0]['data']['d_findings'];
            this.redBarChart.chartData.labels = ["A %", "B %", "C %", "D %"];
            this.redBarChart.chartData.datasets[0].backgroundColor = ["#2ecc71", "#f1c40f", "#e67e22", "#e74c3c"];
            this.percentages = data[0]['data']['percentages'];
            this.redBarChart.chartData.datasets[0].data = data[0]['data']['percentages'];
            this.loaded = true;
          }
          else if (String(data[0]['data']['findings_type']) === "Compliance Audit") {
            this.graph_text = UserService.getLanguage() === "ltr" ? "Controls Working" : "حالة الإجراءات الرقابية";
            this.always_findings = data[0]['data']['always_findings'];
            this.mostly_findings = data[0]['data']['mostly_findings'];
            this.sometimes_findings = data[0]['data']['sometimes_findings'];
            this.never_findings = data[0]['data']['never_findings'];
            this.untested_findings = data[0]['data']['untested_findings'];
            this.redBarChart.chartData.labels = ["Always %", "Mostly %", "Sometimes %", "Never %", "Untested %"];
            this.redBarChart.chartData.datasets[0].backgroundColor = ["#2ecc71", "#f1c40f", "#e67e22", "#e74c3c", "#7f8c8d"];
            this.percentages = data[0]['data']['percentages'];
            this.redBarChart.chartData.datasets[0].data = data[0]['data']['percentages'];
            this.loaded = true;

          }
          else if (String(data[0]['data']['findings_type']) === "Remedial Actions") {
            this.graph_text = UserService.getLanguage() === "ltr" ? "Implementation Status" : "وضع تطبيق التوصيات";
            this.implemented_findings = data[0]['data']['implemented_findings'];
            this.in_progress_findings = data[0]['data']['in_progress_findings'];
            this.not_started_findings = data[0]['data']['not_started_findings'];
            this.overdue_findings = data[0]['data']['overdue_findings'];
            this.redBarChart.chartData.labels = ["Implemented %", "In Progress %", "Not Started %", "Overdue %"];
            this.redBarChart.chartData.datasets[0].backgroundColor = ["#2ecc71", "#f1c40f", "#7f8c8d", "#e74c3c"];
            this.percentages = data[0]['data']['percentages'];
            this.redBarChart.chartData.datasets[0].data = data[0]['data']['percentages'];
            this.loaded = true;
          }
          else {
            this.loaded = false;
          }

          if (data[0]['data']['has_remedial_actions'] === true && String(data[0]['data']['findings_type']) !== "Remedial Actions") {
            this.has_remedial_actions = true;
            this.findings_type_two = "Remedial Actions";
            this.implemented_findings = data[0]['data']['implemented_findings'];
            this.in_progress_findings = data[0]['data']['in_progress_findings'];
            this.not_started_findings = data[0]['data']['not_started_findings'];
            this.overdue_findings = data[0]['data']['overdue_findings'];
            this.remedialBarChart.chartData.labels = ["Implemented %", "In Progress %", "Not Started %", "Overdue %"];
            this.remedialBarChart.chartData.datasets[0].backgroundColor = ["#2ecc71", "#f1c40f", "#7f8c8d", "#e74c3c"];

            this.percentages = data[0]['data']['percentagesRemedialActions'];
            this.remedialBarChart.chartData.datasets[0].data = data[0]['data']['percentagesRemedialActions'];
            this.loaded = true;
          }



          // this.teammembers = teamMembers;
          // console.log(this.stores);
          // console.log(this.visitsdata);
          // this.initBigChart(this.stores[0]);
          // this.redBarChart.chartData.datasets[0].data = [this.recurringcount, this.newcount];
          // this.retentionChart.chartData.datasets[0].data = Object.values(this.customerdetentiondata);
          // this.retentionChart.chartData.labels = Object.keys(this.customerdetentiondata);
      });
      // PDFObject.embed("http://aicj.jo/wp-content/uploads/2019/07/F.S_AICJ_31-12-2018.pdf", "#pdfdisplay");
    }

  };
</script>
<style lang='scss'>

@import '~@fullcalendar/core/main.css';
@import '~@fullcalendar/daygrid/main.css';

</style>
